/*
* Reminder bids (order search) for authenticated users
*/

import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import * as _ from 'lodash';
import moment from 'moment';
import * as React from 'react';
import { Button, Modal, Row, SplitButton, MenuItem, ButtonToolbar } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import VirtualizedSelect from 'react-virtualized-select';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as Actions from '../actions';
import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import * as AppUtilities from '../common/apputilities';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { FormUtilities } from '../common/formutilities';
import { GridCellDropdownActionsReminderBids, ReminderBidActionKeys, } from '../common/grid/grid-cell-components/gridcell-dropdown-actions-bids-reminders';
import { CellRTLWithTruncate, CellWithTruncate } from '../common/grid/grid-cell-components/gridcell-renderers';
import { GridUtilities } from '../common/grid/gridutilities';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import AppConfiguration from '../config/configuration';
import { OrderPricing, OrderStatuses, OrderServiceLevels } from '../order/orderpricing';
import * as ReduxQueries from '../queries';
import { ExcelExport } from '@progress/kendo-react-excel-export';

import { withState } from './with-state';
import { isNullOrUndefined } from 'util';

const StatefulGrid = withState(Grid);

export interface IReminderBidsProps extends AppComp.IAppComponentProps {
    dispatch?: any;
    filterByClients?: any;
    filterByRegions?: any;
    filterBySelectedOrderIds?: any;
    filterByServiceLevels?: any;
    filterByStatuses?: any;
    forceRequest?: any;
    navigateTo?: any;
    searchReminderBidsFilterClient?: any;
    searchReminderBidsFilterFromCompletionDate?: any;
    searchReminderBidsFilterFromReminderDate?: any;
    searchReminderBidsFilterFromSentDate?: any;
    searchReminderBidsFilterRegion?: any;
    lastRequestDate?: any;
    searchReminderBidsFilterServiceLevel?: any;
    searchReminderBidsFilterStatus?: any;
    searchReminderBidsFilterToCompletionDate?: any;
    searchReminderBidsFilterToReminderDate?: any;
    searchReminderBidsFilterToSentDate?: any;
    searchReminderBidsFilterUnsolicitedBid?: any;
    updateReminderBid?: any;
    newOrder?: any;
    updateReminderBidsReminderDate?: any;
    updateReminderBidsSendReminderEmail?: any;
    updateReminderBids3YearPlanStatus?: any;
}

export interface IReminderBidsState extends AppComp.IAppComponentState {
    orderChanges?: any;
    gridVirtualSkip?: any;
    gridVirtualTake?: any;
    gridFilter?: any;
    showModalSendBidReminder?: boolean;
    showModalUpdateOrder?: boolean;
    showModalUpdateOrderId?: any;
    orderModalFormChanges?: any;
    orderBidsChanges?: any;
    gridHeaderSelected?: boolean;
    headerCheckbox?: boolean;
    selected?: any;
    keys?: any;
}

export const DefaultGridPageTake: number = 10; // 50;
export const DefaultFollowUpAddInterval = 7;
export const DefaultFollowUpAddPeriod = 'days';

export class ReminderBids extends AppComp.AppComponent<IReminderBidsProps, IReminderBidsState> {
    public MomentDateFormat: string = AppConfiguration.getMomentShortDateFormat();
    public anyOptionText: string = this.appTextFilterOptionAny();
    public originalExtendedOrderCache: Array<any> = [];
    public originalExtendedOrderBidsCache: Array<any> = [];
    public originalOrderModalFormDataCache: {};
    public lastRequestDateCache = 0;
    public selectedOrders: Array<any> = [];
    public _export;

    public constructor(props: IReminderBidsProps) {
        super(props, 'app.reminder-bids.');

        this.state = {
            orderChanges: [],
            gridVirtualSkip: 0,
            gridVirtualTake: DefaultGridPageTake,
            gridFilter: undefined,
            showModalSendBidReminder: false,
            showModalUpdateOrder: false,
            showModalUpdateOrderId: 0,
            orderModalFormChanges: {},
            orderBidsChanges: {},
            headerCheckbox: false,
            gridHeaderSelected: false,
        };
    }

    /* COMPONENT LIFECYCLE EVENT HANDLERS */
    public componentDidUpdate() {
        // Order modal
        // let resetOrderModalFormData = this.getOrderModalFormChangesResetRequired();

        // if (resetOrderModalFormData && _.size(this.state.orderModalFormChanges)) {
        //     this.setState({ orderModalFormChanges: {} });
        // }

        let resetFormData = this.getRowSelectedResetRequired();
        let resetFormData2 = this.getOrderModalFormChangesResetRequired();

        // if ((resetFormData && _.size(this.state.orderChanges)) || (resetFormData2 && _.size(this.state.orderModalFormChanges))) {
        if (resetFormData || resetFormData2) {
            // console.log(`componentDidUpdate resetFormData ${resetFormData} resetFormData2 ${resetFormData2} resetting`);
            this.setState({ orderChanges: [], gridHeaderSelected: false, headerCheckbox: false, orderModalFormChanges: {} });
        }
    }

    public componentDidMount() {
        const enforce = this.enforceAdminOrEmployeeOnly();

        if (enforce) { this.props.navigateTo(NavigationLinks.clientDashboardHome()); }
    }

    /* FUNCTIONALITY */
    public getRowSelectedResetRequired() {
        let resetFormData = false;

        // Props values
        const prevVal = _.get(this.props, 'lastRequestDate');

        // Cached values
        const cacheVal = this.lastRequestDateCache;

        // Determine if reset required
        resetFormData = (_.isEqual(prevVal, cacheVal)) ? false : true;

        // console.log(`getFormChangesResetRequired prevVal ${prevVal} cacheVal ${cacheVal} resetFormData ${resetFormData}`);

        return resetFormData;
    }

    public getOrderModalFormChangesResetRequired() {
        let result = false;

        const pa = Formatters.getInt(this.state, 'showModalUpdateOrderId');

        // Cached values
        const ca = Formatters.getInt(this.originalOrderModalFormDataCache, 'orderId');

        // Determine if formdata state and cache needs reset due to changing associd or invid
        if (pa && ca) {
            result = (pa !== ca) ? true : false;
        }

        // console.log(`getOrderModalFormChangesResetRequired pa ${pa} ca ${ca} result ${result}`);

        return result;
    }

    public handleFormInputChange(e: any, x: any) {
        const getChangesResult = this.getOrderModalFormChanges(e, x);

        if (getChangesResult.applyChanges) {
            this.setState({
                orderModalFormChanges: getChangesResult.formChanges
            });
        }
    }

    public handleGridFilterChange(event: any) {
        this.setState({
            gridFilter: event.filter,
        });
    }

    public getOrderModalFormChanges(e: any, x: any) {
        let result = {
            applyChanges: false,
            formChanges: {},
            formChangesResult: {},
        };

        let fieldName = '';
        let newValue;

        let formChangesCopy = _.cloneDeep(this.state.orderModalFormChanges);

        if (_.get(e, 'target.props.name')) {
            // Kendo form element
            if (_.has(e, 'target.combobox')) {
                // combobox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'target.value');
            } else {
                // assume textbox
                fieldName = _.get(e, 'target.props.name', '');
                newValue = _.get(e, 'value');
            }
        } else {
            const eventTargetType = _.get(e, 'target.type', '');

            switch (eventTargetType) {
                case 'textarea':
                case 'text':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                case 'kendo-dropdownlist':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value', '');
                    break;

                case 'virtualized-select':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(x, 'value');
                    break;

                case 'delete-button':
                    fieldName = _.get(e, 'target.name', '');
                    newValue = _.get(e, 'target.value');
                    break;

                default:
                    console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
                    break;
            }
        }

        // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

        if (!fieldName) { return result; }

        let applyChange = false;
        let origVal = _.get(this.originalOrderModalFormDataCache, fieldName);
        let formChangesResult = {};
        if (_.isArray(origVal)) {
            if (_.isArray(newValue)) {
                if (!_.isEqual(origVal, newValue)) {
                    _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
                    _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
                    applyChange = true;
                } else {
                    applyChange = false;
                }
            } else {
                if (_.includes(origVal, newValue)) {
                    // console.log(`original array already contained val ${newValue} origVal`, origVal);
                    applyChange = false;
                } else {
                    const formChangesArr = _.get(formChangesCopy, fieldName, []);
                    // console.log(`${fieldName} formChangesArr`, formChangesArr);
                    if (_.includes(formChangesArr, newValue)) {
                        // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
                        applyChange = false;
                    } else {
                        formChangesArr.push(newValue);
                        _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
                        _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
                        applyChange = true;
                        // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
                    }
                }
            }
        } else {
            if (String(newValue) !== String(origVal)) {
                // New value
                _.set(formChangesCopy, fieldName, newValue);
                _.set(formChangesResult, fieldName, newValue);
                applyChange = true;
            } else {
                // Same as orig val
                if (_.has(formChangesCopy, fieldName)) {
                    _.unset(formChangesCopy, fieldName);
                    _.set(formChangesResult, fieldName, newValue);
                    applyChange = true;
                }
            }
        }

        if (applyChange) {
            result.applyChanges = true;
            result.formChanges = _.cloneDeep(formChangesCopy);
            result.formChangesResult = _.cloneDeep(formChangesResult);
        }

        // console.log(`getFormChanges returns result`, result);

        return result;
    }

    public getDefaultOrderUpdateObject(associationId: any, orderId: any, statusOptions: any) {
        const folUpDate = moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();
        const result = _.cloneDeep({
            statusOptions: statusOptions,
            associationId: associationId,
            orderId: orderId,
            statusId: '-1',
            followUpDate: folUpDate, // DefaultNewInviteExpirationDate(),
            notes: '',
            rowSelected: false,
        });

        return result;
    }

    public getFormData(orderIn: any, orderId: any, statuses: any, orderRows: any) {
        let timerName = 'getFormData';
        // let timerName = 'getFormData: order/ordersMerged init';
        // console.time(timerName);
        const order = _.merge(orderIn, this.state.orderModalFormChanges);
        const ordersMerged = _.merge({}, orderRows, this.state.orderChanges);
        // console.timeEnd(timerName);

        // timerName = 'getFormData: updateOrderModalStatusOptions init';
        // console.time(timerName);
        const updateOrderModalStatusOptions = (_.size(statuses)) ?
            _.orderBy(statuses.map((c) => _.merge({}, { value: Formatters.getInt(c, 'statusId'), text: Formatters.getStr(c, 'name') })), 'value')
            : [];
        // console.timeEnd(timerName);

        const associationId = Formatters.getInt(order, 'associationId');

        // timerName = 'getFormData: updateOrderObj init';
        // console.time(timerName);
        let updateOrderObj = _.get(this.state.orderModalFormChanges, 'updateOrder', this.getDefaultOrderUpdateObject(associationId, orderId, updateOrderModalStatusOptions));
        // console.timeEnd(timerName);

        // timerName = 'getFormData: result init';
        // console.time(timerName);
        let result = {
            associationId: Formatters.getInt(order, 'associationId'),
            orderId: orderId,
            followUpDate: _.get(order, 'followUpDate'),
            status: _.get(order, 'status'),

            followUpNotesAdd: Formatters.getStr(order, 'followUpNotesAdd'),
            followUpNotesDelete: _.get(order, 'followUpNotesDelete', []),
            followUpNotes: _.get(order, 'followUpNotes', []),

            orderStatusOptions: (_.size(updateOrderModalStatusOptions)) ? updateOrderModalStatusOptions : [],

            updateOrder: updateOrderObj,

            updateNewFollowUpDate: _.get(order, 'updateNewFollowUpDate'),
            newFollowUpDate: new Date(),

            reminderBids: _.cloneDeep(ordersMerged),
            orderRows: _.cloneDeep(orderRows),
            headerSelected: Formatters.getBool(this.state, 'gridHeaderSelected'),
        };
        // console.timeEnd(timerName);

        // timerName = 'getFormData: updateNewFollowUpDate';
        // console.time(timerName);
        // New due date
        if (result.updateNewFollowUpDate) {
            // Follow up date entered
            _.set(result, 'newFollowUpDate', moment(new Date(result.updateNewFollowUpDate)).toDate());
        } else {
            // No follow up date entered - default
            // const folUpDate = moment(new Date(result.followUpDate)).add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();
            const folUpDate = moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate();
            _.set(result, 'newFollowUpDate', folUpDate);
        }
        // console.timeEnd(timerName);

        // timerName = 'getFormData: followUpNotes';
        // console.time(timerName);
        // Follow up notes
        if (_.size(result.followUpNotes)) {
            result.followUpNotes = _.filter(result.followUpNotes, (o) => Formatters.getStr(o, 'notes') !== '');
            if (_.size(result.followUpNotes)) {
                result.followUpNotes = _.orderBy(result.followUpNotes, ['created'], ['desc']);
            }
        }
        // console.timeEnd(timerName);

        // timerName = 'getFormData: followUpNotesDelete';
        // console.time(timerName);
        if (_.size(result.followUpNotesDelete)) {
            result.followUpNotes = _.omitBy(result.followUpNotes, (o) => _.includes(result.followUpNotesDelete, o.objectId));
        }
        // console.timeEnd(timerName);

        // timerName = 'getFormData: merge final result';
        // console.time(timerName);
        const res = _.merge(result, this.state.orderModalFormChanges);
        // console.timeEnd(timerName);

        // console.log(`getformdata END orderrows.len ${_.size(res.orderRows)} reminderBids.len ${_.size(res.reminderBids)}`);

        return res;
    }

    public getOrderModalFormChangesCount() {
        return _.size(this.state.orderModalFormChanges);
    }

    public extendGridData(records: Array<any>, recordChanges: Array<any>) {
        // Extend grid row data
        if (!records) { return []; }

        const extended = records.map(r => {
            // let timerName = 'extendGridData: records.map';
            // console.time(timerName);

            let record = _.cloneDeep(r);

            record.associationName = Formatters.getStr(record, 'association.name', '', true);
            record.contactFirstName = Formatters.getStr(record, 'contact.firstName', '', true);
            record.contactLastName = Formatters.getStr(record, 'contact.lastName', '', true);
            record.clientName = Formatters.getStr(record, 'client.name', '', true);
            record.clientPhone = Formatters.formatPhoneNumber(Formatters.getStr(record, 'client.phone'), '', '');
            record.orderStatus = Formatters.getStr(record, 'status.name', '');

            // TODO: GET THIS FROM STATE.ORDERCHANGES
            record.rowSelected = Formatters.getBool(record, 'rowSelected');
            // console.log(`extendGridData orderid ${record.orderId} record.rowSelected ${record.rowSelected}`);

            record.contactNameFormatted = Formatters.composeClientContactLetter(_.get(record, 'contact'), true, false);

            // Bid Dates
            record.bidDateFormatted = (Formatters.getStr(record, 'bidDate')) ? moment(record.bidDate).format(this.MomentDateFormat) : '';
            record.bidSentDateFormatted = (Formatters.getStr(record, 'bidSentDate')) ? moment(record.bidSentDate).format(this.MomentDateFormat) : '';
            record.bidReminderDateFormatted = (Formatters.getStr(record, 'reminderBidDate')) ? moment(record.reminderBidDate).format(this.MomentDateFormat) : '';

            // Prices
            record.bidAcceptedPrice = Formatters.getFloat(record, 'acceptedPrice');

            // Service level
            record.serviceLevelName = Formatters.getStr(record, 'serviceLevel.name');

            // Follow up dates
            const followUpDateRawDate = new Date(record.followUpDate);
            record.followUpDateFormatted = (followUpDateRawDate) ? moment(followUpDateRawDate).format(this.MomentDateFormat) : '';

            if (!record.followUpDateNew) {
                record.followUpDateNew = new Date(moment().add(DefaultFollowUpAddInterval, DefaultFollowUpAddPeriod).toDate());
            }

            record.level1Economy = OrderPricing.getOrderPricingLevel1Economy(record.pricingMatrix);

            // View order detail link
            record.viewOrderDetailLinkObj = {
                text: '',
                href: '',
                title: '',
                orderId: 0,
            };
            if (record.orderId) {
                record.viewOrderDetailLinkObj.text = this.appText('view-order-detail-link-title');
                record.viewOrderDetailLinkObj.href = NavigationLinks.orderDetail(record.orderId);
                record.viewOrderDetailLinkObj.orderId = Formatters.getInt(record, 'orderId');
            }

            record.updateOrderObj = {
                text: '',
                href: '',
                title: '',
                orderId: Formatters.getInt(record, 'orderId'),
                associationId: Formatters.getInt(record, 'associationId'),
                clientId: Formatters.getInt(record, 'clientId'),
                clickHandler: undefined,
                menuItems: _.stubArray(),
            };

            record.updateOrderObj.menuItems = [
                {
                    eventKey: ReminderBidActionKeys.viewAssociation,
                    text: this.appText('view-association-link-title'),
                    id: record.associationId,
                    associationId: record.associationId,
                    clientId: record.clientId,
                    orderId: record.orderId,
                },
                {
                    eventKey: ReminderBidActionKeys.viewClient,
                    text: this.appText('view-client-link-title'),
                    id: record.clientId,
                    associationId: record.associationId,
                    clientId: record.clientId,
                    orderId: record.orderId,
                },
                {
                    eventKey: ReminderBidActionKeys.createOrder,
                    text: this.appText('create-order-link-title'),
                    id: record.associationId,
                    associationId: record.associationId,
                    clientId: record.clientId,
                    orderId: record.orderId,
                },
            ];

            if (record.orderId) {
                record.updateOrderObj.text = this.appText('view-order-detail-link-title');
                record.updateOrderObj.href = NavigationLinks.orderDetail(record.orderId);
                record.updateOrderObj.clickHandler = (e: any, k: any, o: any, a: any) => this.handleOrderActionButton(e, k, o, a);
            }

            let recChanges = _.find(recordChanges, { orderId: record.orderId });
            if (recChanges) {
                record = _.merge(record, _.omit(recChanges, ['orderId', 'associationId', 'clientId']));
            }

            // console.timeEnd(timerName);

            return record;
        });

        // if (this.originalExtendedOrderCache.length === 0) { this.originalExtendedOrderCache = _.cloneDeep(extended); }
        // if (this.originalExtendedOrderBidsCache.length === 0) { this.originalExtendedOrderBidsCache = _.cloneDeep(extended); }

        return extended;
    }

    // #region FORM INPUT HANDLERS
    public handleFormHtmlInputChange(content: any, source: any, fieldName: any) {
        if (source === 'api' || !fieldName) { return; }

        // const prevFieldHtml = Formatters.getStr(formData, fieldName);
        const prevFieldHtml = Formatters.getStr(this.state.orderModalFormChanges, 'bodyContent');
        const newHtml = String(content);

        let modelChanges = _.stubArray();
        if (prevFieldHtml !== newHtml) {
            modelChanges.push({ fieldName: fieldName, newValue: newHtml });
        }

        if (_.size(modelChanges)) {
            let cloneFormChanges = _.cloneDeep(this.state.orderModalFormChanges);

            modelChanges.forEach((o) => {
                _.set(cloneFormChanges, o.fieldName, _.cloneDeep(o.newValue));
            });

            this.setState({ orderModalFormChanges: cloneFormChanges });
        }
    }

    // Prepare value for other/misc select handlers
    public getHandleSelectMiscOtherValue(e: any) {
        const result = _.get(e, 'value', '');

        return result;
    }

    public handleSelectClient(e: any) {
        const value = this.getHandleSelectMiscOtherValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterClient(value));
    }

    public handleSelectRegion(e: any) {
        const value = this.getHandleSelectMiscOtherValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterRegion(value));
    }

    public handleSelectStatus(e: any) {
        const value = this.getHandleSelectMiscOtherValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterStatus(value));
    }

    public handleSelectUnsolicited(e: any) {
        const value = this.getHandleSelectMiscOtherValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterUnsolicitedBid(value));
    }

    public handleSelectServiceLevel(e: any) {
        const value = this.getHandleSelectMiscOtherValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterServiceLevel(value));
    }

    // Prepare date value for date select handlers
    public getHandleSelectDateValue(e: any) {
        const result = e ? e.format(this.MomentDateFormat) : '';

        return result;
    }

    // Handle Bid Completion Date
    public handleSelectFromCompletionDate(e: any) {
        const value = this.getHandleSelectDateValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterFromCompletionDate(value));
    }

    public handleSelectToCompletionDate(e: any) {
        const value = this.getHandleSelectDateValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterToCompletionDate(value));
    }

    // Handle Bid Reminder Date
    public handleSelectFromReminderDate(e: any) {
        const value = this.getHandleSelectDateValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterFromReminderDate(value));
    }

    public handleSelectToReminderDate(e: any) {
        const value = this.getHandleSelectDateValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterToReminderDate(value));
    }

    // Handle Bid Sent Date
    public handleSelectFromSentDate(e: any) {
        const value = this.getHandleSelectDateValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterFromSentDate(value));
    }

    public handleSelectToSentDate(e: any) {
        const value = this.getHandleSelectDateValue(e);
        this.props.dispatch(Actions.searchReminderBidsFilterToSentDate(value));
    }

    // #endregion

    // Other UI event handlers
    public handleGridItemChange(event: any, itemField: any, itemValueNew: any) {
        let timerName = 'handleGridItemChange: init';
        // console.time(timerName);
        const itemValueOld = event.dataItem[itemField];
        const orderId = _.get(event, 'dataItem.orderId');
        const origItem = _.find(this.originalExtendedOrderCache, { 'orderId': orderId });
        const origValue = _.get(origItem, itemField);
        // console.timeEnd(timerName);

        // console.log(`handleGridItemChange orderId ${orderId} field ${itemField} changed from ${itemValueOld} to ${itemValueNew}. orig ${origValue}`); // , { origItem, event });

        timerName = 'handleGridItemChange: oChangesClone init';
        // console.time(timerName);
        let oChangesClone = _.cloneDeep(this.state.orderChanges);
        if (!_.find(oChangesClone, { 'orderId': orderId })) {
            const newItem = { orderId: orderId, rowSelected: false };
            oChangesClone.push(newItem);
        }
        // console.timeEnd(timerName);

        timerName = 'handleGridItemChange: order find';
        // console.time(timerName);
        let order = _.find(oChangesClone, { 'orderId': orderId });
        // console.timeEnd(timerName);

        timerName = 'handleGridItemChange: order changes applied';
        // console.time(timerName);
        if (order && _.get(order, itemField) !== itemValueNew) {
            if (itemValueNew === origValue) {
                // New value same as original, delete any change
                _.unset(order, itemField);
                // console.log(`unset ${orderId}`);
            } else {
                // New value differs from original
                _.set(order, itemField, itemValueNew);
                // console.log(`set ${orderId}`);
            }

            if (_.keys(_.omit(order, 'orderId')).length === 0) {
                // No more changes for this item, remove it
                oChangesClone = _.reject(oChangesClone, { orderId: orderId });
                // console.log(`reject ${orderId}`);
            }

            // _.set(event.dataItem, itemField, itemValueNew);

            // console.log(`handleGridItemChange orderId ${orderId} setState`); // , { oChangesClone });

            this.setState({ orderChanges: oChangesClone });
        }
        // console.timeEnd(timerName);
    }

    public handleGridPageChange(event: any) {
        this.setState({
            gridVirtualSkip: event.page.skip,
            gridVirtualTake: event.page.take,
        });
    }

    public handleOrderActionButton(e: any, k: any, o: any, a?: any) {
        switch (k) {
            case ReminderBidActionKeys.editOrder:
                this.props.history.push(NavigationLinks.orderEdit(o));
                break;

            case ReminderBidActionKeys.createOrder:
                this.handleOrderActionCreateOrder(Formatters.getInt(a, 'associationId'), Formatters.getInt(a, 'clientId'));
                break;

            case ReminderBidActionKeys.viewAssociation:
                this.props.history.push(NavigationLinks.associationDetail(o));
                break;

            case ReminderBidActionKeys.viewClient:
                this.props.history.push(NavigationLinks.clientDetail(o));
                break;

            default:
            case ReminderBidActionKeys.viewDetails:
                this.props.history.push(NavigationLinks.orderDetail(o));
                break;
        }
    }

    public handleOrderActionCreateOrder(assocId: any, clientId: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { association: { associationId: assocId } },
            { client: { clientId: clientId } },
        );

        this.props.newOrder(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // FORCE RELOAD
                const newOrderId = _.get(response, 'body.orderId');

                this.props.history.push(NavigationLinks.orderEdit(newOrderId));
            } else {
                // Error during creation...
            }
        });
    }

    // Modal UI event handlers
    public handleShowModalUpdateOrder(e: any, o: any, a: any) {

        let formChanges = _.cloneDeep(this.state.orderModalFormChanges);
        const newOrderUpdateObj = this.getDefaultOrderUpdateObject(a, o, []);

        _.set(formChanges, 'updateOrder', newOrderUpdateObj);

        this.setState({ orderModalFormChanges: formChanges, showModalUpdateOrderId: o, showModalUpdateOrder: true });
    }

    public handleShowModalSendBidReminder(selected: any, keys: any) {
        let formChanges = _.cloneDeep(this.state.orderModalFormChanges);
        this.setState({ orderModalFormChanges: formChanges, showModalSendBidReminder: true, selected: selected, keys: keys });
    }

    public handleCloseModalUpdateOrder() {
        this.setState({ showModalUpdateOrder: false, showModalUpdateOrderId: 0 });
    }

    public handleCloseModalSendBidReminder() {
        this.setState({ showModalSendBidReminder: false, selected: undefined, keys: undefined });
    }

    public handleUpdateOrderModalButton(e: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const rows: Array<any> = this.extendGridData(this.props.search.results, this.state.orderChanges);
        const currentOrderId = Formatters.getInt(this.state, 'showModalUpdateOrderId');
        const currentOrder = (currentOrderId > 0) ? _.find(rows, { orderId: this.state.showModalUpdateOrderId }) : {};

        let payload = _.cloneDeep(_.get(this.state, 'orderModalFormChanges.updateOrder'));

        const changeData = {
            updateOrder: payload
        };

        this.props.updateReminderBid(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.originalOrderModalFormDataCache = {};

                this.setState({ orderModalFormChanges: {}, showModalUpdateOrder: false });

                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    /* GRID UI HANDLERS */
    public handleGridSelectionChange(e: any, formData: any) {
        const orderId = Formatters.getInt(e, 'dataItem.orderId');
        const isChecked = Formatters.getBool(e, 'syntheticEvent.target.checked');
        // console.log(`handleGridSelectionChange orderId ${orderId} new checked value ${isChecked}`); // , { e, formData });
        this.handleGridItemChange(e, 'rowSelected', isChecked);
    }

    public handleGridHeaderSelectionChange(e: any, formData: any) {
        const isChecked = Formatters.getBool(e, 'syntheticEvent.target.checked');
        const prevChecked = Formatters.getBool(formData, 'gridHeaderSelected');

        if (isChecked) {
            let rBids = _.get(formData, 'orderRows', []); // _.get(formData, 'reminderBids', []);
            const rBidsChanged = _.map(rBids, (o) => {
                return {
                    orderId: Formatters.getInt(o, 'orderId'),
                    rowSelected: isChecked,
                };
            });

            this.setState({ orderChanges: rBidsChanged, gridHeaderSelected: isChecked });
        } else {
            this.setState({ orderChanges: _.stubArray(), gridHeaderSelected: isChecked });
        }
    }

    public handleRemoveAnyRemindersButton(selected: any, k: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const rBidsFiltered2 = _.filter(selected, (o) => Formatters.getStr(o, 'reminderBidDate') !== '');

        const rBidsPayload = _.map(rBidsFiltered2, (o) => {
            return {
                _id: Formatters.getStr(o, '_id'),
                associationId: Formatters.getInt(o, 'associationId'),
                orderId: Formatters.getInt(o, 'orderId'),
                reminderDate: '',
            };
        });

        const changeData = _.merge(
            {},
            { orders: rBidsPayload },
        );

        this.props.updateReminderBidsReminderDate(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // FORCE RELOAD
                this.originalOrderModalFormDataCache = {};
                this.lastRequestDateCache = 0;

                this.setState({ orderChanges: [], gridHeaderSelected: false, headerCheckbox: false, orderModalFormChanges: {} });

                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleSendReminderEmailsButton(selected: any, k: any) {
        const token = _.get(this.props, 'authsession.access_token', '');

        const rBidsFiltered2 = _.filter(selected, (o) => Formatters.getStr(o, 'reminderBidDate') !== '');

        const rBidsPayload = _.map(rBidsFiltered2, (o) => {
            return {
                _id: Formatters.getStr(o, '_id'),
                associationId: Formatters.getInt(o, 'associationId'),
                orderId: Formatters.getInt(o, 'orderId'),
                reminderDate: '',
            };
        });

        const changeData = _.merge(
            {},
            { orders: rBidsPayload },
            { bodyContent: _.get(this.state.orderModalFormChanges, 'bodyContent') },
            { bodyContentStart: _.get(this.state.orderModalFormChanges, 'bodyContentStart') },
            { bodyContentMid: _.get(this.state.orderModalFormChanges, 'bodyContentMid') },
            { bodyContentEnd: _.get(this.state.orderModalFormChanges, 'bodyContentEnd') },
            { headerText: _.get(this.state.orderModalFormChanges, 'headerText') },
        );

        this.props.updateReminderBidsSendReminderEmail(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // FORCE RELOAD
                this.originalOrderModalFormDataCache = {};
                this.lastRequestDateCache = 0;

                this.setState({ orderChanges: [], gridHeaderSelected: false, headerCheckbox: false, orderModalFormChanges: {}, showModalSendBidReminder: false, selected: undefined, keys: undefined });

                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleBulkStatusChangeButton(selected: any, eKey: any) {
        console.log(`handleBulkStatusChangeButton`, { selected, eKey });
        const token = _.get(this.props, 'authsession.access_token', '');

        let newOrderStatusId = 0;
        let rBidsFiltered2 = _.stubArray();
        switch (eKey) {
            case ReminderBidActionKeys.setStatus3YrPendingStart:
                rBidsFiltered2 = _.filter(selected, (o) => Formatters.getInt(o, 'status.statusId') === OrderStatuses.ORDER_3_YEAR_RENEWAL);
                newOrderStatusId = OrderStatuses.ORDER_3_YEAR_PENDING_START;
                break;

            case ReminderBidActionKeys.setStatus3YrRenewal:
                rBidsFiltered2 = _.filter(selected, (o) => Formatters.getInt(o, 'status.statusId') === OrderStatuses.ORDER_3_YEAR_PENDING_START);
                newOrderStatusId = OrderStatuses.ORDER_3_YEAR_RENEWAL;
                break;

            default:
                break;
        }

        if (!_.size(rBidsFiltered2)) { return; }

        const rBidsPayload = _.map(rBidsFiltered2, (o) => {
            return {
                _id: Formatters.getStr(o, '_id'),
                associationId: Formatters.getInt(o, 'associationId'),
                orderId: Formatters.getInt(o, 'orderId'),
                statusId: newOrderStatusId,
            };
        });

        const changeData = _.merge(
            {},
            { orders: rBidsPayload },
        );

        // console.log(`handleBulkStatusChangeButton`, { changeData });

        this.props.updateReminderBids3YearPlanStatus(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                // FORCE RELOAD
                this.originalOrderModalFormDataCache = {};
                this.lastRequestDateCache = 0;

                this.setState({ orderChanges: [], gridHeaderSelected: false, headerCheckbox: false, orderModalFormChanges: {} });

                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleCreateNewOrdersButton(e: any, formData: any) {
        // console.log('handleCreateNewOrdersButton', { e, formData });
    }

    /* RENDERERS */
    public renderUpdateOrderModal = (oStatuses: any, currentOrder: any, formData?: any) => {
        const buttonSuccessDisabled = false;

        const currentOrderId = Formatters.getInt(currentOrder, 'orderId');
        const currentOrderAssocName = Formatters.getStr(currentOrder, 'association.name');
        const currentOrderAssocId = Formatters.getInt(currentOrder, 'associationId');
        const currentOrderStatusName = Formatters.getStr(currentOrder, 'status.name');
        const currentOrderFollowUpDateFormatted = Formatters.getStr(currentOrder, 'followUpDateFormatted');
        const currentOrderFollowUpDateFormattedNew = Formatters.getStr(currentOrder, 'followUpDateFormattedNew');
        const currentOrderFollowUpDateNew = _.get(formData, 'updateOrder.followUpDate');

        if (currentOrderId <= 0) { return (<div />); }

        const orderStatusOptionsRaw = _.filter(_.get(oStatuses, 'options', []), o => Formatters.getInt(o, 'value') >= 0);
        const orderStatusOptions = (_.size(orderStatusOptionsRaw)) ? orderStatusOptionsRaw.map((c) => _.merge({}, { value: Formatters.getInt(c, 'value'), text: Formatters.getStr(c, 'label') })) : [];

        if (!currentOrder || !currentOrderId || !currentOrderAssocId) { return (<div />); }

        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 }; // colInputXs: 8 };

        let inputPropsLargeTextDebounced = _.merge({}, defaultInputProps, {
            handleChange: (n, v) => undefined,
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            colLabelXs: 12,
            colInputXs: 12,
        });

        let inputPropsSmallDate = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        const inputPropsNew = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        return (
            <Modal enforceFocus={false} show={this.state.showModalUpdateOrder} onHide={() => this.handleCloseModalUpdateOrder()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.update-order.title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <div className="outstanding-bids-update-order-modal-content">
                            <p className="outstanding-bids-update-order-modal-header-text">
                                <i className="fa fa-info-circle" /> {this.appText('modals.update-order.header-text')}.
                            </p>
                        </div>

                        <form onSubmit={e => { e.preventDefault(); }}>
                            <div className="outstanding-bids-update-order-modal-content">
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.association"
                                            label={this.appText('modals.update-order.association')}
                                            value={(<Link to={NavigationLinks.associationDetail(currentOrderAssocId)} title={currentOrderAssocName}>{currentOrderAssocName}</Link>)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.orderId"
                                            label={this.appText('modals.update-order.order-id')}
                                            value={(<Link to={NavigationLinks.orderDetail(currentOrderId)} title={String(currentOrderId)}>{currentOrderId}</Link>)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.followUpDate"
                                            label={this.appText('modals.update-order.current-follow-up-date')}
                                            value={currentOrderFollowUpDateFormatted}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDisabledInputHidden
                                            name="_updateOrder.orderStatus"
                                            label={this.appText('modals.update-order.current-order-status')}
                                            value={currentOrderStatusName}
                                            // {...inputPropsLargeTextDebounced}
                                            {...inputPropsNew}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <hr />

                            <div className="outstanding-bids-update-order-modal-content">
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDropdownListInput
                                            name="updateOrder.statusId"
                                            clearable={false}
                                            label={this.appText('modals.update-order.new-order-status')}
                                            value={Formatters.getInt(formData, 'updateOrder.statusId')}
                                            data={orderStatusOptions}
                                            textField="text"
                                            valueField="value"
                                            onChange={(o) => {
                                                this.handleFormInputChange({ target: { name: 'updateOrder.statusId', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o);
                                            }}
                                            {...inputPropsVirtualizedSelect}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoDateInput
                                            name="updateOrder.followUpDate"
                                            clearable={true}
                                            label={this.appText('modals.update-order.new-order-follow-up-date')}
                                            value={Formatters.formatDateForKendoDateInput(_.get(formData, 'updateOrder.followUpDate'))}
                                            {...inputPropsSmallDate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="form-group">
                                    <Col xs={3} xl={12}>
                                        <KendoWrappers.KendoTextarea
                                            name="updateOrder.notes"
                                            label={this.appText('modals.update-order.new-order-follow-up-notes')}
                                            rows={2}
                                            cols={40}
                                            value={Formatters.getStr(formData, 'updateOrder.notes')}
                                            {...inputPropsFullWidthOwnRow}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={buttonSuccessDisabled} onClick={(e) => this.handleUpdateOrderModalButton(e)}>{this.appText('modals.update-order.button-update')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalUpdateOrder()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public renderSendBidReminderModal = (formData?: any) => {
        const buttonSuccessDisabled = false;
        const defaultInputProps = { colLabelXs: 4, colInputXs: 8 }; // colInputXs: 8 };

        const inputPropsHtmlEditor = _.merge({}, defaultInputProps, {
            colLabelXs: 12,
            colInputXs: 12,
            className: 'text-content-quill-container',
        });

        let inputPropsLargeTextDebounced = _.merge({}, defaultInputProps, {
            handleChange: (n, v) => undefined,
            className: 'inventory-detail-input-full-width',
        });

        const inputPropsNew = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { this.handleFormInputChange(n, v); },
            handleChange: (n, v) => { this.handleFormInputChange(n, v); },
        });

        if (isNullOrUndefined(this.state.orderModalFormChanges.bodyContentStart)) {
            const orderModalFormChangesOrig = _.cloneDeep(this.state.orderModalFormChanges);
            const mergedFormChanges = _.merge({}, orderModalFormChangesOrig, { bodyContentStart: this.appText('modals.send-reminder-email.default-content-start') });
            this.setState({ orderModalFormChanges: mergedFormChanges });
        }

        if (isNullOrUndefined(this.state.orderModalFormChanges.bodyContentMid)) {
            const orderModalFormChangesOrig = _.cloneDeep(this.state.orderModalFormChanges);
            const mergedFormChanges = _.merge({}, orderModalFormChangesOrig, { bodyContentMid: this.appText('modals.send-reminder-email.default-content-mid') });
            this.setState({ orderModalFormChanges: mergedFormChanges });
        }

        if (isNullOrUndefined(this.state.orderModalFormChanges.bodyContentEnd)) {
            const orderModalFormChangesOrig = _.cloneDeep(this.state.orderModalFormChanges);
            const mergedFormChanges = _.merge({}, orderModalFormChangesOrig, { bodyContentEnd: this.appText('modals.send-reminder-email.default-content-end') });
            this.setState({ orderModalFormChanges: mergedFormChanges });
        }

        if (isNullOrUndefined(this.state.orderModalFormChanges.headerText)) {
            const orderModalFormChangesOrig = _.cloneDeep(this.state.orderModalFormChanges);
            const mergedFormChanges = _.merge({}, orderModalFormChangesOrig, { headerText: this.appText('modals.send-reminder-email.default-header') });
            this.setState({ orderModalFormChanges: mergedFormChanges });
        }

        let start = _.get(this.state.orderModalFormChanges, 'bodyContentStart');
        const brandingKeyText = '{{brandingKey}}';
        let mid = _.get(this.state.orderModalFormChanges, 'bodyContentMid');
        const inviteAssocNameText = '{{inviteAssocName}}';
        let end = _.get(this.state.orderModalFormChanges, 'bodyContentEnd');

        return (
            <Modal enforceFocus={false} size="xl" show={this.state.showModalSendBidReminder} onHide={() => this.handleCloseModalSendBidReminder()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{this.appText('modals.send-reminder-email.modal-title')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <form onSubmit={e => { e.preventDefault(); }}>
                            <div className="reminder-bids-send-reminder-modal-content">
                                <Row>
                                    <Col xs={8} xl={12}>
                                        <KendoWrappers.KendoTextInputDebounced
                                            name="headerText"
                                            label={this.appText('modals.send-reminder-email.header-text')}
                                            required={false}
                                            value={_.get(this.state.orderModalFormChanges, 'headerText')}
                                            onChange={(n, v) => this.handleFormInputChange(n, v)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                    <hr />
                                </Row>
                                <Row className="form-group">
                                    <Col xs={8} xl={12}>
                                        <KendoWrappers.KendoTextInputDebounced
                                            name="bodyContentStart"
                                            label={this.appText('modals.send-reminder-email.body-content-start')}
                                            value={_.get(this.state.orderModalFormChanges, 'bodyContentStart')}
                                            handleChange={(n, v) => this.handleFormInputChange(n, v)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                        <hr />
                                        <Row xs={8} xl={12}>
                                            <Col xs={2} xl={5}>This is where the email inserts the:  </Col>
                                            <Col xs={6} xl={7}>{brandingKeyText}</Col>
                                        </Row>
                                        <hr />
                                    </Col>
                                </Row>

                                <Row className="form-group">
                                    <Col xs={8} xl={12}>
                                        <KendoWrappers.KendoTextInputDebounced
                                            name="bodyContentMid"
                                            label={this.appText('modals.send-reminder-email.body-content-mid')}
                                            value={_.get(this.state.orderModalFormChanges, 'bodyContentMid')}
                                            handleChange={(n, v) => this.handleFormInputChange(n, v)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                        <hr />
                                        <Row xs={8} xl={12}>
                                            <Col xs={2} xl={5}>This is where the email inserts the:  </Col>
                                            <Col xs={6} xl={7}>{inviteAssocNameText}</Col>
                                        </Row>
                                        <hr />
                                    </Col>
                                </Row>

                                <Row className="form-group">
                                    <Col xs={8} xl={12}>
                                        <KendoWrappers.KendoTextInputDebounced
                                            name="bodyContentEnd"
                                            label={this.appText('modals.send-reminder-email.body-content-end')}
                                            value={_.get(this.state.orderModalFormChanges, 'bodyContentEnd')}
                                            handleChange={(n, v) => this.handleFormInputChange(n, v)}
                                            {...inputPropsLargeTextDebounced}
                                        />
                                    </Col>
                                </Row>

                            </div>
                            <hr />
                            <div>
                                <Row xs={8} xl={12}>
                                    <Modal.Header closeButton={false}>
                                        <Modal.Title>Preview:</Modal.Title>
                                    <Col xs={8} xl={12}>{start + brandingKeyText + mid + inviteAssocNameText + end}</Col>
                                    </Modal.Header>
                                </Row>
                            </div>
                            <hr />
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={buttonSuccessDisabled} onClick={(e) => this.handleSendReminderEmailsButton(_.get(this.state, 'selected'), _.get(this.state, 'keys'))}>{this.appText('send-reminder-email')}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalSendBidReminder()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public export = () => {
        this._export.save();
    }

    public render() {
        const { lastRequestDate, ...rest } = this.props;

        const rows: Array<any> = this.extendGridData(this.props.search.results, this.state.orderChanges);
        const formData = this.getFormData({}, 0, this.props.filterByStatuses, rows);

        if (this.getRowSelectedResetRequired() || !_.size(this.originalExtendedOrderCache)) {
            this.lastRequestDateCache = lastRequestDate;
            this.originalOrderModalFormDataCache = _.cloneDeep(formData);
            this.originalExtendedOrderCache = _.cloneDeep(formData);
        }

        const clients = FormUtilities.getExtendedFilterOptions(this.props.filterByClients, 'clientId', 'label', this.anyOptionText, -1);
        const regions = FormUtilities.getExtendedFilterOptions(this.props.filterByRegions, 'regionId', 'label', this.anyOptionText, -1);

        let filterByStatusesNew = _.stubArray();
        if (AppUtilities.isArrayWithLength(this.props.filterByStatuses)) {
            let fStatuses = _.each(this.props.filterByStatuses, (c: any) => { c.sort = c.statusId; return c; });

            filterByStatusesNew = fStatuses;
        }

        const statuses = FormUtilities.getExtendedFilterOptions(filterByStatusesNew, 'statusId', 'sort', this.appText('filter-option-status-won-sent'), OrderStatuses.JOB_SENT_OR_WON_STATUSES, OrderStatuses.JOB_SENT_OR_WON_STATUSES);

        let filterByUnsolicited: Array<any> = [
            { value: 1, name: this.appTextCommon('forms.filter-option-yes') },
            { value: 0, name: this.appTextCommon('forms.filter-option-no') },
        ];
        const unsolicited = FormUtilities.getExtendedFilterOptions(filterByUnsolicited, 'value', 'value', this.appTextCommon('forms.filter-option-show-all'), -1, -1);

        let filterByServiceLevelsNew: any = _.stubArray();
        if (_.size(this.props.filterByServiceLevels)) {
            let fServiceLevels = _.each(this.props.filterByServiceLevels, (c: any) => { c.sort = c.serviceLevelId; return c; });

            fServiceLevels.push({
                name: this.appText('filter-option-service-level-3-year'),
                sort: OrderServiceLevels.ORDER_3_YEAR_PLANS_SERVICE_LEVELS * -1,
                serviceLevelId: OrderServiceLevels.ORDER_3_YEAR_PLANS_SERVICE_LEVELS,
            });

            filterByServiceLevelsNew = fServiceLevels;
        }

        let serviceLevels = FormUtilities.getExtendedFilterOptions(filterByServiceLevelsNew, 'serviceLevelId', 'label', this.anyOptionText, -1, -1);

        // Dates
        const fromBidSentDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.fromSentDate);
        const toBidSentDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.toSentDate);

        const fromBidCompletionDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.fromCompletionDate);
        const toBidCompletionDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.toCompletionDate);

        const fromBidReminderDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.fromReminderDate);
        const toBidReminderDateSelected = FormUtilities.getDatePickerSelectedValue(this.props.search.filters.toReminderDate);

        const pageTitle = this.appTextResultsAndPageTitle(rows.length);

        const rowRenderer = (trElement: React.ReactElement<any>, dataItem: any) => {
            const trProps = { ...trElement.props };
            const addClass = _.get(dataItem.dataItem, GridUtilities.KendoGridAddRowClassFieldName, '');
            if (addClass) { trProps.className += ` ${addClass}`; }

            const cloned = React.cloneElement(trElement, { ...trProps }, trElement.props.children);
            return cloned;
        };

        const gridOpts = {
            key: 'reminder-bids-grid-1',
            data: rows,
            groupable: true,
            scrollable: true,
            filterable: true,
            resizable: true,
            pageable: { buttonCount: 5, pageSizes: [10, 20, 50, 'all'] },
            sortable: true,
            rowRender: rowRenderer,
            selectedField: 'rowSelected',
            headerSelectionChange: (e) => {
                this.handleGridHeaderSelectionChange(e, formData);
            },
            handleRemoveReminders: (s: any, k: any = '') => { this.handleRemoveAnyRemindersButton(s, k); },
            handleSendReminderEmails: (s: any, k: any = '') => { this.handleShowModalSendBidReminder(s, k); }, // { this.handleSendReminderEmailsButton(s, k); },
            handleSetStatusReminders: (s: any, k: any) => { this.handleBulkStatusChangeButton(s, k); },
            handleExportToExcel: () => { this.export(); },
            appTextFunc: (p: any) => this.appText(p),
            style: { width: '100%', height: '50%' },
            total: _.size(rows),
        };

        const filterStatusId = Formatters.getInt(this.props, 'search.filters.statusId');
        let isIn3YearMode = false;
        if (_.includes([OrderStatuses.ORDER_3_YEAR_PENDING_START, OrderStatuses.ORDER_3_YEAR_RENEWAL, OrderStatuses.ORDER_3_YEAR_PLANS_STATUSES], filterStatusId)) {
            isIn3YearMode = true;
        }
        const rowSelectedColumn = [
            <Column key="rowSelected" field="rowSelected" title=" " headerSelectionValue={Formatters.getBool(this.state, 'gridHeaderSelected')} width="30px" editable={false} resizable={true} filterable={false} sortable={false} />
        ];

        const updateOrderColumn = [
            <Column
                key="updateOrderObj"
                field="updateOrderObj"
                title=" "
                editable={false}
                cell={GridCellDropdownActionsReminderBids}
                headerClassName={`k-grid-column-row-dropdown-actions`}
                filterable={false}
            />
        ];

        const excelExportToolbar = [
            <GridToolbar key="excel-export-toolbar">
                <Button key="reminder-bids-toolbar" className="reminder-bids-grid-toolbar-button" disabled={false} bsSize="sm" bsStyle={'info'} onClick={this.export}>
                    <i className="fa fa-file-excel-o" /> {this.appText('export-to-excel')}
                </Button>
            </GridToolbar>
        ];

        const grid = (

            <ExcelExport
                ref={(exporter) => { this._export = exporter; }}
                data={gridOpts.data}
                fileName={'ReminderBids.xlsx'}
            >
                <StatefulGrid {...gridOpts}>
                    {...excelExportToolbar}
                    {...rowSelectedColumn}
                    <Column key="associationId" field="associationId" title={this.appTextGridColumnHeader('association-id')} width="90px" editable={false} resizable={true} cell={CellWithTruncate} filter="numeric" />
                    <Column key="associationName" field="associationName" title={this.appTextGridColumnHeader('association-name')} editable={false} cell={CellWithTruncate} />
                    <Column key="contactName" field="contactNameFormatted" title={this.appTextGridColumnHeader('contact-name')} width="110px" editable={false} cell={CellWithTruncate} />
                    <Column key="clientName" field="clientName" title={this.appTextGridColumnHeader('client-name')} editable={false} cell={CellWithTruncate} />
                    <Column key="clientPhone" field="clientPhone" title={this.appTextGridColumnHeader('client-phone')} width="105px" editable={false} cell={CellWithTruncate} />
                    <Column key="orderStatus" field="orderStatus" title={this.appTextGridColumnHeader('order-status')} width="120px" editable={false} cell={CellWithTruncate} />
                    <Column key="bidSent" field="bidSentDateFormatted" title={this.appTextGridColumnHeader('bid-sent-date')} width="80px" editable={false} cell={CellWithTruncate} />
                    <Column key="bidReminderDate" field="bidReminderDateFormatted" title={this.appTextGridColumnHeader('bid-reminder-date')} width="80px" editable={false} cell={CellWithTruncate} />
                    <Column key="bidAccepted" field="bidAcceptedPrice" title={this.appTextGridColumnHeader('accepted-price')} width="90px" className="right-align" format="{0:c0}" editable={false} filter="numeric" />
                    <Column key="serviceLevel" field="serviceLevelName" title={this.appTextGridColumnHeader('service-level')} width="110px" editable={false} cell={CellRTLWithTruncate} />
                    {...updateOrderColumn}
                </StatefulGrid>
            </ExcelExport>
        );

        const filterForm = (
            <form onSubmit={e => { e.preventDefault(); }}>
                <Row className="form-group">
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-status')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={statuses.filter}
                            name="status-filter"
                            onChange={e => this.handleSelectStatus(e)}
                            options={statuses.options}
                            value={this.props.search.filters.statusId}
                        />
                    </Col>

                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-region')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={regions.filter}
                            name="region-filter"
                            onChange={e => this.handleSelectRegion(e)}
                            options={regions.options}
                            value={this.props.search.filters.regionId}
                        />
                    </Col>

                    <Col xs={4} xl={3}>
                        <label className="control-label">{this.appText('filter-by-client')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={clients.filter}
                            name="client-filter"
                            onChange={e => this.handleSelectClient(e)}
                            options={clients.options}
                            value={this.props.search.filters.clientId}
                        />
                    </Col>
                </Row>

                <Row className="form-group">
                    <Col xs={2} xl={2}>
                        <label className="control-label">{this.appText('filter-by-service-level')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={serviceLevels.filter}
                            name="serviceLevel-filter"
                            onChange={e => this.handleSelectServiceLevel(e)}
                            options={serviceLevels.options}
                            value={this.props.search.filters.serviceLevelId}
                        />
                    </Col>
                    <Col xs={2} xl={2}>
                        <label className="control-label">{this.appText('filter-by-unsolicited-bid')}</label>
                        <VirtualizedSelect
                            clearable={false}
                            filterOptions={unsolicited.filter}
                            name="unsolicited-filter"
                            onChange={e => this.handleSelectUnsolicited(e)}
                            options={unsolicited.options}
                            value={this.props.search.filters.unsolicitedBid}
                        />
                    </Col>
                </Row>

                <Row className="form-group reminder-bids-filters">
                    { /* Bid Sent Date Filters */}
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-from-bid-sent-date')}</label>
                        <DatePicker isClearable={true} className="form-control" onChange={e => { this.handleSelectFromSentDate(e); }} selected={fromBidSentDateSelected} />
                    </Col>
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-to-bid-sent-date')}</label>
                        <DatePicker isClearable={true} className="form-control" onChange={e => { this.handleSelectToSentDate(e); }} selected={toBidSentDateSelected} />
                    </Col>

                    { /* Bid Completion Date Filters */}
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-from-bid-completion-date')}</label>
                        <DatePicker isClearable={true} className="form-control" onChange={e => { this.handleSelectFromCompletionDate(e); }} selected={fromBidCompletionDateSelected} />
                    </Col>
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-to-bid-completion-date')}</label>
                        <DatePicker isClearable={true} className="form-control" onChange={e => { this.handleSelectToCompletionDate(e); }} selected={toBidCompletionDateSelected} />
                    </Col>

                    { /* Bid Reminder Date Filters */}
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-from-bid-reminder-date')}</label>
                        <DatePicker isClearable={true} className="form-control" onChange={e => { this.handleSelectFromReminderDate(e); }} selected={fromBidReminderDateSelected} />
                    </Col>
                    <Col xs={3} xl={2}>
                        <label className="control-label">{this.appText('filter-by-to-bid-reminder-date')}</label>
                        <DatePicker className="form-control" onChange={e => { this.handleSelectToReminderDate(e); }} selected={toBidReminderDateSelected} />
                    </Col>
                </Row>
            </form>
        );

        const page = (
            <WhiteBoxPageSection title={pageTitle} >
                { /* this.renderUpdateOrderModal(statuses, currentOrder, formData) */}
                {this.renderSendBidReminderModal(formData)}
                <Row>
                    <Col xs={12}>
                        {filterForm}
                    </Col>
                </Row>

                <Row>
                    <Col xs={12}>
                        {grid}
                    </Col>
                </Row>
            </WhiteBoxPageSection>
        );

        // console.timeEnd(timerName);

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getReminderBidsSearchUrl();

const mapPropsToConfigs = (props) => ReduxQueries.Queries.searchReminderBidsRequest(
    getApiUrl(),
    ReduxQueries.PropsAccessToken(props),
    _.get(props, 'search.filters.statusId', OrderStatuses.JOB_SENT_OR_WON_STATUSES),
    _.get(props, 'search.filters.clientId', -1),
    _.get(props, 'search.filters.regionId', -1),
    _.get(props, 'search.filters.fromCompletionDate', ''),
    _.get(props, 'search.filters.toCompletionDate', ''),
    _.get(props, 'search.filters.fromSentDate', ''),
    _.get(props, 'search.filters.toSentDate', ''),
    _.get(props, 'search.filters.fromReminderDate', ''),
    _.get(props, 'search.filters.toReminderDate', ''),
    _.get(props, 'search.filters.unsolicitedBid', -1),
    _.get(props, 'search.filters.serviceLevelId', -1),
    _.get(props, 'search.filters.operator', '')
);

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        lastRequestDate: new Date().getTime(),
        filterByClients: state.entities.reminderBidsClients,
        filterByRegions: state.entities.reminderBidsRegions,
        filterByServiceLevels: state.entities.reminderBidsServiceLevels,
        filterByStatuses: state.entities.reminderBidsStatuses,
        filterBySelectedOrderIds: state.searchFiltersReminderBids.selectedOrderIds,
        search: {
            results: state.entities.reminderBidsResults,
            filters: {
                clientId: state.searchFiltersReminderBids.clientId,
                fromCompletionDate: state.searchFiltersReminderBids.fromCompletionDate,
                fromReminderDate: state.searchFiltersReminderBids.fromReminderDate,
                fromSentDate: state.searchFiltersReminderBids.fromSentDate,
                operator: 'AND',
                regionId: state.searchFiltersReminderBids.regionId,
                serviceLevelId: state.searchFiltersReminderBids.serviceLevelId,
                statusId: state.searchFiltersReminderBids.statusId,
                toCompletionDate: state.searchFiltersReminderBids.toCompletionDate,
                toReminderDate: state.searchFiltersReminderBids.toReminderDate,
                toSentDate: state.searchFiltersReminderBids.toSentDate,
                unsolicitedBid: state.searchFiltersReminderBids.unsolicitedBid,
            }
        },
    });
};

const mapDispatchToProps = dispatch => ({
    dispatch: (d) => dispatch(d),
    navigateTo: (path) => dispatch(push(path)),
    newOrder: (d: any, t: any, o: any) => dispatch(MutateActions.newOrderMutateAsync(d, t, o)),
    searchReminderBidsFilterClient: (v) => dispatch(Actions.searchReminderBidsFilterClient(v)),
    searchReminderBidsFilterFromCompletionDate: (v) => dispatch(Actions.searchReminderBidsFilterFromCompletionDate(v)),
    searchReminderBidsFilterFromReminderDate: (v) => dispatch(Actions.searchReminderBidsFilterFromReminderDate(v)),
    searchReminderBidsFilterFromSentDate: (v) => dispatch(Actions.searchReminderBidsFilterFromSentDate(v)),
    searchReminderBidsFilterRegion: (v) => dispatch(Actions.searchReminderBidsFilterRegion(v)),
    searchReminderBidsFilterServiceLevel: (v) => dispatch(Actions.searchReminderBidsFilterServiceLevel(v)),
    searchReminderBidsFilterStatus: (v) => dispatch(Actions.searchReminderBidsFilterStatus(v)),
    searchReminderBidsFilterToCompletionDate: (v) => dispatch(Actions.searchReminderBidsFilterToCompletionDate(v)),
    searchReminderBidsFilterToReminderDate: (v) => dispatch(Actions.searchReminderBidsFilterToReminderDate(v)),
    searchReminderBidsFilterToSentDate: (v) => dispatch(Actions.searchReminderBidsFilterToSentDate(v)),
    searchReminderBidsFilterUnsolicitedBid: (v) => dispatch(Actions.searchReminderBidsFilterUnsolicitedBid(v)),
    updateReminderBid: (d: any, a: string, o: boolean) => dispatch(MutateActions.updateReminderBidMutateAsync(d, a, o)),
    updateReminderBidsSendReminderEmail: (d: any, a: string, o: boolean) => dispatch(MutateActions.updateReminderBidsSendReminderEmailMutateAsync(d, a, o)),
    updateReminderBidsReminderDate: (d: any, a: string, o: boolean) => dispatch(MutateActions.updateReminderBidsReminderDateMutateAsync(d, a, o)),
    updateReminderBids3YearPlanStatus: (d: any, a: string, o: boolean) => dispatch(MutateActions.updateReminderBids3YearPlanStatusMutateAsync(d, a, o)),
});

const ReminderBidsContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(ReminderBids);

export default withRouter(ReminderBidsContainer);



// WEBPACK FOOTER //
// ./src/reminder-bids/index.tsx